import { usePageTitle } from "../hooks/usePageTitle";
import ActiveDropScreen from "../components/drop/ActiveDropScreen";

const ShelfDrop = () => {
    usePageTitle("shelf_drop");
    return <ActiveDropScreen module="shelf" titleKey="shelf_drop" />;
};

export default ShelfDrop;
